/**
 * Guard de rutas: solo deja entrar si el JWT del usuario tiene
 * `is_superadmin=true`. Si no, redirige a /socios con un toast.
 */
import type { ReactNode } from "react";
import { Navigate } from "react-router-dom";

import { useAuth } from "../auth/useAuth";

interface Props {
  children: ReactNode;
}

export function SuperadminGate({ children }: Props): JSX.Element {
  const { state } = useAuth();
  if (!state) return <Navigate to="/login" replace />;
  if (!state.isSuperadmin) return <Navigate to="/socios" replace />;
  return <>{children}</>;
}
